import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";


export const BrandList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
  useEffect(() => {
    updateMainHeader("Inventory");
    labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Brand": "/brand/list" },
  ]);

  const source = {
    url: "brands/list",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const
  };

  const columns: IColumns[] = [
    { header: "Brand Name", fieldName: "BrandName" },
    { header: "Description", fieldName: "Description", tooltip: true },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        const brandId = row.BrandId;
        if (!brandId) {
          console.error("No valid ID found in row:", row);
          showMessage("Invalid brand data - missing ID", "error");
          return;
        }

        if (action === "Edit") {
          navigate(`/brand/${brandId}`);
        } else if (action === "Delete") {
          setSelectedId(brandId);
          setPopupOpen(true);
        }
      },
    },
  ];

  const handleClick = () => {
    navigate("/brand");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="brandGrid"
            title="Brand"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            searchBox={{ searchMode:"query" }}
            addButton={{ label: "Add New Brand", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
      <ConfirmationPopup
        type="DELETE"
        apiUrl="brands"
        id={selectedId}
        confirmMessage="Are you sure you want to delete this brand?"
        open={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        onConfirm={(data: any) => {
          dispatch(resetDataComponent("brandGrid"));
          if (data.success === true) {
            showMessage(data?.message, "success");
          } else {
            showMessage(data?.detail, "error");
          }
        }}
      />
    </Grid>
  );
};
